import { render, staticRenderFns } from "./CopyQuote.vue?vue&type=template&id=fff30edc&scoped=true&"
import script from "./CopyQuote.vue?vue&type=script&lang=js&"
export * from "./CopyQuote.vue?vue&type=script&lang=js&"
import style0 from "./CopyQuote.vue?vue&type=style&index=0&id=fff30edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff30edc",
  null
  
)

export default component.exports